import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore } from '@store/authStore'
import { ROUTES } from '@constants/routes'

/**
 * Blocks super_admin from company-admin operational routes (events, users, etc.).
 * Super admins manage companies only — operational work is done by company admins.
 */
export function CompanyAdminOnlyRoute() {
  const user = useAuthStore((s) => s.user)

  if (user?.role === 'super_admin') {
    return <Navigate to={ROUTES.ADMIN.COMPANIES.LIST} replace />
  }

  return <Outlet />
}
